var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bbrCom_copyright"}},[_vm._v("(c) "+_vm._s(new Date().getFullYear())+" Sportradar AG, St. Gallen, Switzerland"),_c('br'),_vm._v("(c) "+_vm._s(new Date().getFullYear())+" Kyodo News Digital Co., Ltd."),_c('br'),_vm._v("※各データはSportradar AGが独自入力したものです。"),_c('br',{staticClass:"bbrCom_ndP"}),_vm._v("公式記録とは異なる場合があります。")])
}
var staticRenderFns = []

export { render, staticRenderFns }